import(/* webpackMode: "eager" */ "/home/runner/work/DSDashboard/DSDashboard/src/app/page.js");
